@charset "UTF-8";

/* src/app/modulos/intra-net/intra-net.component.scss */
.iframe-container {
  width: 100%;
  height: calc(100vh - 100px);
  background-color: #ffffff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
}
.iframe-full {
  width: 100%;
  height: 100%;
  border: none;
  display: block;
}
/*# sourceMappingURL=intra-net.component.css.map */
